import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import ListaFormularios from '../Formularios/ListaFormularios';
import MsgUtils from '../Tools/MsgUtils';
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import DateConverter from '../Tools/DateConverter';
import EncuestaRespond from '../Formularios/EncuestaRespond';
import ModalMensajeInteractivo from '../utilsComponentes/ModalMensajeInteractivo';
import GenerarPdfFormulario from '../Formularios/GenerarPdfFormulario';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
function RegistroFormulario(props) {
    const { setLoading } = useContext(ContextGloball);
    const { selectColaborador,regional,tipo } = props;
    const [ventana, setVentana] = useState(0);
    const [formularios, setFormularios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [tituloModal, setTituloModal] = useState('');
    const [tipoModal, setTipoModal] = useState('');
    const [selectFormulario, setSelectFormulario] = useState(null);
    const [showMsg, setShowMsg] = useState(false);
    const [showMsgd, setShowMsgd] = useState(false);
    const [soloVer, setSoloVer] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [adjuntosArch, setAdjuntosArch] = useState([]);
    const actualizarContenido = async () => {
        setShowModal(false);
        await getFormulariosAsignados();
    }
    const getFormulariosAsignados = async () => {
        try {
            setLoading(true);
            var listaForm = await ConsultasFormularios.getFormulariosAsignados({ 'regional': regional, 'idEmpleado': selectColaborador.ID_EMPLEADO,tipo })
            if (listaForm.ok) {
                setFormularios(listaForm.ok);
            } else {
                MsgUtils.msgError(listaForm.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false);
        }
    }
    const verResponderFormulario = async (formulario) => {
        var infoUser = JSON.parse(localStorage.getItem('__react_session__'))
        try {
            var respuesta = await ConsultasFormularios.getRespuestaFormulario({ regional: regional, 'ID_FORMULARIO': formulario.ID_FORMULARIO, 'ID_EMPLEADO': infoUser.idSession });
            if (respuesta.ok) {
                if (infoUser.idSession == formulario.CREADO_POR) {
                    setSoloVer(false);
                } else {
                    setSoloVer(true);
                }
                setSelectFormulario({ ...formulario, 'ID_RESPUESTA': respuesta.ok.length == 0 ? 0 : respuesta.ok[0].ID_RESPUESTA });
                setTipoModal('R');
                setTituloModal('Respuesta Formulario');
                setShowModal(true);
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const guardarRespuesta = async (valor) => {
        try {
            var infoUser = JSON.parse(localStorage.getItem('__react_session__'))
            var respuesta = await ConsultasFormularios.guardarRespuestaFormulario(
                {
                    'regional': regional, 'ID_RESPUESTA': valor,
                    'ID_FORMULARIO': selectFormulario.ID_FORMULARIO, 'ID_EMPLEADO': infoUser.idSession
                })
            if (respuesta.ok) {
                setShowModal(false);
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const eliminarFormulario = async (valor) => {
        try {
            var eliminarF = await ConsultasFormularios.eliminarFormulario(
                {
                    'regional': regional,
                    'ID_FORMULARIO': valor.ID_FORMULARIO
                })
            if (eliminarF.ok) {
                setShowMsgd(false);
                MsgUtils.msgCorrecto(eliminarF.ok);
                setActualizar(!actualizar);
            } else {
                MsgUtils.msgError(eliminarF.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const cerrarMensaje = (val) => {
        if (val == true) {
            setShowMsg(false);
            setShowModal(false);
        } else {
            setShowMsg(false);
        }
    }
    const eliminarAdjunto = async (dato) => {
        try {
            if (window.confirm('¿Esta seguro de eliminar el archivo adjunto ?')) {
                var info = JSON.parse(localStorage.getItem('__react_session__'));
                var result = await ConsultasFormularios.eliminarAdjunto({ 'ID_ADJUNTO': dato.ID_ADJUNTO, 'regional': regional });
                if (result.ok) {
                    var resulaD = adjuntosArch.filter((item) => item.ID_ADJUNTO != dato.ID_ADJUNTO)
                    setAdjuntosArch([...resulaD]);
                    MsgUtils.msgCorrecto(result.ok);
                } else {
                    MsgUtils.msgError(result.error);
                }
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const irDocumentosAdjuntos = async (formulario) => {
        try {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            var documentos = await ConsultasFormularios.obtenerAdjuntos({ 'ID_FORMULARIO': formulario.ID_FORMULARIO, 'regional': regional });
            if (documentos.ok) {
                setAdjuntosArch(documentos.ok)
                setSelectFormulario(formulario);
                setTituloModal("Adjuntar Archivos");
                setTipoModal('A');
                setShowModal(true);
                setSoloVer(true)
            } else {
                MsgUtils.msgError(documentos.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const generarPdfRespuestas = async (dato) => {
        try {
            setLoading(true);
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            var respuesta = await ConsultasFormularios.getRespuestaFormulario(
                { regional: regional, 'ID_FORMULARIO': dato.ID_FORMULARIO, 'ID_EMPLEADO': dato.CREADO_POR });
            if (respuesta.ok) {
                var encuesta = await ConsultasFormularios.getCuestionario({
                    'regional': regional, "ENCUESTA": {...dato,'ID_RESPUESTA': respuesta.ok.length == 0 ? 0 : respuesta.ok[0].ID_RESPUESTA }, "ID_EMPLEADO": dato.CREADO_POR
                })
                if (encuesta.ok) {
                    console.log(encuesta.ok,selectColaborador)
                    var pdfResult = await GenerarPdfFormulario.generarFormRespondido(encuesta.ok,selectColaborador,regional);
                    if(pdfResult.ok){
                        MsgUtils.msgCorrecto(pdfResult.ok);
                    }else{
                        MsgUtils.msgError(encuesta.error);
                    }
                } else {
                    MsgUtils.msgError(encuesta.error);
                }
            } else {
                MsgUtils.msgError(respuesta.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false)
        }
    }
    const cargarArchivo = async (e) => {
        var archiv = e.target.files[0];
        var extencion = archiv.name.substring(archiv.name.lastIndexOf('.') + 1);
        var nameArchivo = archiv.name.substring(0, archiv.name.lastIndexOf('.')).replace(/\./g, '').replace(/\s+/g, '');
        if (archiv.size / 1000000 < 10.5) {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            var formData = new FormData()
            formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }),
                `${nameArchivo}.${extencion}` + "." + regional + "." + info.idSession + "." + selectFormulario.ID_FORMULARIO);
            try {
                var result = await ConsultasFormularios.agregarDocumento(formData);
                if (result.status == 200) {
                    if (result.data.ok) {
                        var nombre_arch = 'ADJUNTO_FORM_' + regional + '_' + result.data.ok.V_ID + '.' + extencion
                        setAdjuntosArch([...adjuntosArch, { 'ID_ADJUNTO': result.data.ok.V_ID, 'NOMBRE_LINK': nombre_arch, 'NOMBRE_ARCH': nameArchivo }])
                    } else {
                        MsgUtils.msgError(result.data.error)
                    }
                } else {
                    MsgUtils.msgError(result.status + ' ' + result.statusText)
                }
            } catch (error) {
                MsgUtils.msgError(error.message);
            }
        } else {
            MsgUtils.msgError("Coloque Imagen < 10.5 Megas")
        }
    }
    useEffect(() => {
        getFormulariosAsignados()
    }, [actualizar])
    return (
        <>
            <div className='container-fluid py-1'>
                <div className='row row-cols-2 gx-1'>
                    <div className='col col-10 text-center fw-bold text-light my-auto'>Formularios Asociados al Colaborador</div>
                    <div className='col col-2 my-auto text-end'>
                        <button className='btn btn-light btn-sm text-success'
                            onClick={() => { setSoloVer(false); setTituloModal('Formulario'); setTipoModal('S'); setShowModal(true); }}>
                            <i className="fa-solid fa-circle-plus fa-xl"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className='table table-dark table-striped table-hover table-sm table-bordered border-light'>
                    <thead className='text-center'>
                        <tr>
                            <th>Fecha</th>
                            <th>Formulario</th>
                            <th>Creado Por</th>
                            <th>Adjuntar</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {formularios.map((formulario, index) => {
                            return (
                                <tr key={index}>
                                    <td>{DateConverter.formatoFecha(formulario.FECHA)}</td>
                                    <td>{formulario.TITULO}, FORMULARIO: {formulario.TIPO_ENCUESTA}</td>
                                    <td>{formulario.NOMBREX}</td>
                                    <td>
                                        <button className='btn btn-sm btn-transparent text-secondary w-100'
                                            title='Adjuntar Archivos para referencia a este formulario'
                                            onClick={() => irDocumentosAdjuntos(formulario)}>
                                            <i className="fa-solid fa-folder-open fa-2xl"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button className='btn btn-transparent btn-sm text-light'
                                            title='Descargar Pdf del formulario llenado'
                                            onClick={() => generarPdfRespuestas(formulario)}>
                                            <i className="fa-solid fa-file-pdf fa-2xl"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button className='btn btn-transparent btn-sm text-danger'
                                            title='Eliminar formulario asignado al colaborador'
                                            onClick={() => { setSelectFormulario(formulario); setShowMsgd(true) }}>
                                            <i className="fa-solid fa-trash fa-2xl"></i>
                                        </button>
                                    </td>
                                    <td className='text-center'>
                                        <button className='btn btn-sm btn-transparent text-light fs-5 m-0 p-0'
                                            title='Ver las respuesta del formulario asignado'
                                            onClick={() => verResponderFormulario(formulario)}>
                                            <i className="fa-solid fa-ellipsis fa-2xl"></i></button>
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <Modal show={showModal} onHide={() => { soloVer == true ? setShowModal(false) : setShowMsg(true) }}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='bg-dark bordered-light'
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 mx-2'>
                    <Modal.Title bsPrefix='text-light' id="contained-modal-title-vcenter">
                        {tituloModal}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px`, margin: 0, padding: 0 }}>
                    {tipoModal == 'A' &&
                        <div className='container-fluid py-1'>
                            <div className='row row-cols g-1'>
                                <div className='col'>
                                    <div className='table-responsive'>
                                        <table className="table table-sm table-dark table-striped table-hover table-bordered border-secondary">
                                            <thead>
                                                <tr>
                                                    <th style={{ maxWidth: '90px', minWidth: '90px' }}>#</th>
                                                    <th className='col'>NOMBRE</th>
                                                    <th style={{ maxWidth: '90px', minWidth: '90px' }}></th>
                                                    <th style={{ maxWidth: '90px', minWidth: '90px' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {adjuntosArch.map((adjunt, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th>{adjunt.ID_ADJUNTO}</th>
                                                            <td>{adjunt.NOMBRE_ARCH}</td>
                                                            <td style={{ maxWidth: '90px', minWidth: '90px' }}>
                                                                <a className='btn btn-transparent btn-sm text-light'
                                                                    title='Descargar Archivo Adjunto'
                                                                    target='_blanck'
                                                                    href={`${server}/imagenes/${adjunt.NOMBRE_LINK}`}>
                                                                    <i className="fa-regular fa-folder-open fa-2xl"></i>
                                                                </a>
                                                            </td>
                                                            <td style={{ maxWidth: '90px', minWidth: '90px' }}>
                                                                <button className='btn btn-transparent btn-sm text-danger'
                                                                    title='Eliminar Archivo Adjunto'
                                                                    onClick={() => eliminarAdjunto(adjunt)}>
                                                                    <i className="fa-solid fa-trash fa-2xl"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='col text-center' style={{ minWidth: '120px', maxWidth: '120px' }}>
                                    <label className='btn fs-1 text-success text-center lh-1'>
                                        <i className="fa-solid fa-folder-plus"></i>
                                        <input type="file" accept=".xlsx, .xls, .doc, .docx, .pdf" onChange={(e) => cargarArchivo(e)} />
                                    </label>
                                </div>
                            </div>
                        </div>}
                    {tipoModal == 'S' && <ListaFormularios selectColaborador={selectColaborador} collback={() => actualizarContenido()} tipo={'RD'} tipoFormulario={tipo} regional={regional}/>}
                    {tipoModal == 'R' && 
                        <EncuestaRespond selectFormu={selectFormulario} soloVer={soloVer} 
                            teclado={false} tipo='F' collback={(valor) => guardarRespuesta(valor)} 
                            reg={regional} userResp={selectColaborador}/>}
                </Modal.Body>
            </Modal>
            <ModalMensajeInteractivo msg={"Esta seguro de salir sin guardar ?"} collback={cerrarMensaje} show={showMsg} />
            <ModalMensajeInteractivo msg={"Esta seguro de Eliminar el formulario ?"}
                collback={(val) => {
                    if (val == true) {
                        eliminarFormulario(selectFormulario);
                    } else {
                        setShowMsgd(false)
                        setSelectFormulario(null);
                    }
                }}
                show={showMsgd} />
        </>
    )
}

export default RegistroFormulario